let globalConfig = {
  // imgFormat: 'image/jpg,image/jpeg,image/png,image/bmp,image/tiff',
  imgFormat: '.jpg,.jpeg,.png',
}

export default globalConfig;
